import { useCallback, useState } from "react";
import { clearStorage, setStoredAuthProvider } from "../utils/storage";
import { useAtom } from "jotai";
import { userAtom, userProfileAtom } from "../jotai/atoms/user";
import { OAuthProvider } from "@nestcoinco/hyper-api-gateway-api-client";
import { handleInitiateAuth } from "../api-clients/usersAuthClient";

// Includes temporary log out functionality
function useAuth() {
  const [user, setUser] = useAtom(userAtom);
  const [userProfile, setUserProfile] = useAtom(userProfileAtom);
  const [isAuthInProgress, setIsAuthInProgress] = useState(false);

  const handleAuthClick = (
    provider: OAuthProvider,
    redirectPath?: string,
    fallbackPath?: string
  ) => {
    setStoredAuthProvider(provider);
    setIsAuthInProgress(true);
    handleInitiateAuth(provider, redirectPath, fallbackPath).finally(() => {
      setIsAuthInProgress(false);
    });
  };

  const logOut = useCallback(() => {
    setUser(null);
    setUserProfile(null);
    clearStorage();
  }, [setUser, setUserProfile]);

  return {
    isLoggedIn: !!user,
    userProfile,
    isAuthInProgress,
    handleAuthClick,
    logOut,
  };
}

export default useAuth;
